import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Spade } from 'lucide-react';

export default function ProtectedRoute({ children, requireSuper = false }) {
  const { user, loading } = useApp();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-red-600 text-white">
            <Spade className="h-6 w-6" />
          </div>
          <div className="font-clock text-lg font-semibold text-neutral-500 animate-pulse-soft">Загрузка…</div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (requireSuper && !user.isSuperAdmin) return <Navigate to="/admin" replace />;
  return children;
}
